













import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "date-range-stat": () =>
      import("@/components/app/global/stats/_dateRangeStat.vue")
  }
})
export default class RevenueTotalOutstanding extends Vue {
  private calcValue({ data, defaultValue, currency }) {
    if (!data) {
      const prefix = this.$_.get(currency, "prefix", "");
      const suffix = this.$_.get(currency, "suffix", "");
      return `${prefix} ${defaultValue} ${suffix}`;
    }

    const outstanding =
      this.$_.get(data, "total_amount", 0) -
      this.$_.get(data, "paid_amount", 0);
    return (
      (outstanding < 0 ? "-" : "") +
      this.$_.get(data, "currency.prefix", "") +
      this.$_.round(Math.abs(outstanding || 0), 2).toString() +
      this.$_.get(data, "currency.suffix", "")
    );
  }
}
